import React from 'react';
import { useViewModel } from './viewModel';
import View from './View';
import { DetailsContentProps } from './types';

const Main = (props: DetailsContentProps) => {
    const viewModelProps = useViewModel(props);
    return <View {...viewModelProps} />;
};

export { getDetailsContentStyles } from './View';
export default Main;
